import { render, staticRenderFns } from "./EmailArrowRightOutline.vue?vue&type=template&id=05ab13f2"
import script from "./EmailArrowRightOutline.vue?vue&type=script&lang=js"
export * from "./EmailArrowRightOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports